import axios from "axios";
import { getBulkDisplayCount } from "./bulkSelectionModes";

export const BULK_BID_ADJUSTMENT_TYPE = {
  INCREASE_PERCENTAGE: "INCREASE_PERCENTAGE",
  DECREASE_PERCENTAGE: "DECREASE_PERCENTAGE",
  INCREASE_ABSOLUTE: "INCREASE_ABSOLUTE",
  DECREASE_ABSOLUTE: "DECREASE_ABSOLUTE",
  SET_ABSOLUTE: "SET_ABSOLUTE",
  COPY_CPC: "COPY_CPC",
};

/** UI action key → backend adjustmentType enum */
export const UI_ACTION_TO_ADJUSTMENT_TYPE = {
  "increase-by": BULK_BID_ADJUSTMENT_TYPE.INCREASE_PERCENTAGE,
  "decrease-by": BULK_BID_ADJUSTMENT_TYPE.DECREASE_PERCENTAGE,
  "increase-by-abs": BULK_BID_ADJUSTMENT_TYPE.INCREASE_ABSOLUTE,
  "decrease-by-abs": BULK_BID_ADJUSTMENT_TYPE.DECREASE_ABSOLUTE,
  set_bid_as: BULK_BID_ADJUSTMENT_TYPE.SET_ABSOLUTE,
  copy_cpc: BULK_BID_ADJUSTMENT_TYPE.COPY_CPC,
};

export const ADJUSTMENT_TYPE_LABELS = {
  [BULK_BID_ADJUSTMENT_TYPE.INCREASE_PERCENTAGE]: "Increase by %",
  [BULK_BID_ADJUSTMENT_TYPE.DECREASE_PERCENTAGE]: "Decrease by %",
  [BULK_BID_ADJUSTMENT_TYPE.INCREASE_ABSOLUTE]: "Increase by absolute",
  [BULK_BID_ADJUSTMENT_TYPE.DECREASE_ABSOLUTE]: "Decrease by absolute",
  [BULK_BID_ADJUSTMENT_TYPE.SET_ABSOLUTE]: "Set absolute value",
  [BULK_BID_ADJUSTMENT_TYPE.COPY_CPC]: "Copy CPC",
};

export function mapUiActionToAdjustmentType(selectedAction) {
  return UI_ACTION_TO_ADJUSTMENT_TYPE[selectedAction] || null;
}

export function resolveBulkBidValue({ selectedAction, valuePercentage, setAsValue }) {
  if (selectedAction === "copy_cpc") return null;
  if (selectedAction === "set_bid_as") {
    return Number(setAsValue);
  }
  return Number(valuePercentage);
}

export function buildBulkPlacementBidUpdateBody({
  query,
  adjustmentType,
  value,
  email,
  requestedCount,
  defaultBaseValue,
}) {
  const operation = {
    adjustmentType,
    value: Number(value),
  };
  if (defaultBaseValue !== null && defaultBaseValue !== undefined && defaultBaseValue !== "") {
    operation.defaultBaseValue = Number(defaultBaseValue);
  }
  return {
    filters: {
      query: { ...(query || {}) },
    },
    operation,
    email: email || "",
    requestedCount: Number(requestedCount) || 0,
  };
}

export function getRequestedCountForBulk({
  scope,
  selectedIdsCount,
  totalCount,
  excludeIdsCount,
}) {
  return getBulkDisplayCount({
    scope,
    selectedIdsCount,
    totalCount,
    excludeIdsCount,
  });
}

/**
 * PATCH /client/{clientId}/campaigns:bulk-patch-update-campaign
 */
export async function submitBulkPlacementBidUpdate({
  clientId,
  userPlatform = "amazon",
  skipEvents = true,
  body,
  token,
}) {
  const baseUrl = process.env.REACT_APP_ADS_API;
  const url = `${baseUrl}/client/${clientId}/campaigns:bulk-patch-update-campaign?skipEvents=${skipEvents ? "true" : "false"}&source=${userPlatform}`;

  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = token;
  }

  const response = await axios.patch(url, body, { headers });
  return response?.data;
}
